import { render, staticRenderFns } from "./AppWindow.vue?vue&type=template&id=df188242&scoped=true&"
import script from "./AppWindow.vue?vue&type=script&lang=js&"
export * from "./AppWindow.vue?vue&type=script&lang=js&"
import style0 from "./AppWindow.vue?vue&type=style&index=0&id=df188242&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df188242",
  null
  
)

export default component.exports